import axios from "axios";
import { getUnitApiBaseFour, SUB_URL_KCA } from "./BaseUrl";

const getUnitCode = () => {
  const unitCode = localStorage.getItem("unit_code");

  if (!unitCode) {
    throw new Error("unit_code missing");
  }

  return unitCode;
};

const KCADashboardService = {
  getGSMSummaryTotal: async () => {
    try {
      const unitCode = getUnitCode();

      const response = await axios.get(
        `${getUnitApiBaseFour(unitCode)}${SUB_URL_KCA.gsm_summary_total}`
      );

      return response.data;
    } catch (error) {
      console.error("Error fetching GSM summary total:", error);
      return null;
    }
  },
};

export default KCADashboardService;